import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  authContainer: {
    maxWidth: 400,
  },
  loadingWrapper: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  logoContainer: {
    textAlign: 'center',
    margin: theme.spacing(6, 0, 1, 0),
  },
  logo: {
    height: 25,
  },
  footerLinks: {
    textAlign: 'right',
  },
}));
